'use strict'

/**
 * Module qui charge une action d'un controlleur en ajax
 */

const J_URL_HIDDEN = '.j_url'
const J_PAGENUMBER_DATA = 'pagenumber'
const J_PAGE = '.j_page'
const J_REDIRECTION_PARAMETERS = 'redirect'
let backBrowser = true
const J_PAGINATION_METHOD = '.j_pagination_method'
const J_ACTION = 'action'
const J_ACTION_DEGRADATED = 'actiondegradatedproduct'

/*
 * Fonction init permettant notamment la gestion du bouton précédent du navigateur
 * Elle est appelé à chaque fois qu'on charge, la page, et donc le module.
 * Donc on ajoute l'URL en cours à l'history
 */
function init(callback) {
    window.onpopstate = function (event) {
        /**
         * Si on clique sur le bouton précédent du navigateur
         * après le chargement d'une ou plusieurs pages du catalogue,
         * On revient en arrière dans le history autant que de pages ont été chargées
         */
        goToPreviousPage(event)

        if (backBrowser === true && typeof History !== 'function') {
            document.body.scrollTop = document.documentElement.scrollTop = 0
            const State = History.getState()
            const currentPage = State.data.np === undefined ? 1 : State.data.np
            const element = $(
                J_PAGE +
                    '[data-' +
                    J_PAGENUMBER_DATA +
                    "='" +
                    currentPage +
                    "']"
            )
            callback(currentPage, element)
        }

        backBrowser = true

        return false
    }
}

/**
 * Retourne à la page précédente dans le navigateur lorsqu'on
 * est sur une page catalogue avec la paramètre np
 */
function goToPreviousPage(event) {
    if (event === null) {
        return
    }

    if (event.state === 'undefined' || event.state === null) {
        return
    }

    if (event.state.np === 'undefined' || event.state.np === null) {
        return
    }

    window.history.go(parseInt(event.state.np) * -1)
}

/*
 *Efface un paramtre dans l'url, retourne l'url sans ce parametre.
 */
function deleteParameter(key, sourceURL) {
    let rtn = sourceURL.split('?')[0]
    let param
    let paramsArr = []
    const queryString =
        sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : ''
    if (queryString !== '') {
        paramsArr = queryString.split('&')
        for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
            param = paramsArr[i].split('=')[0]
            if (param === key) {
                paramsArr.splice(i, 1)
            }
        }
        if (paramsArr.length) rtn = rtn + '?' + paramsArr.join('&')
    }
    return rtn
}

/*
 * Insert les paramètres dans l'url à l'aide de history.js (documentation dispo sur internet)
 * Si on veut mettre en place le chargement des pages d'un coup (de 1 à 10 par ex.), on doit mustAddPosition à true.
 * Sinon, dans le cas de la pagination classique par ex., on doit mettre à false
 * Si le paramètre existe déjà, on le remplace.
 */
// TODO PUBLIC
function insertParams(params, mustAddPosition) {
    let newUrl = $(J_URL_HIDDEN).first().val()
    let prefix = ''
    let suffix = ''
    let noParameters = false
    let start = -1
    let end = -1

    if (params.hasOwnProperty('ct')) {
        delete params.ct
        newUrl = deleteParameter('ct', newUrl)
    }

    if (params.hasOwnProperty('ctr')) {
        delete params.ctr
        newUrl = deleteParameter('ctr', newUrl)
    }

    if (params.hasOwnProperty('reload') && mustAddPosition === true) {
        // On efface le parametre reload dans l'url
        delete params.reload
        newUrl = deleteParameter('reload', newUrl)
    }
    if (params.hasOwnProperty('index') && mustAddPosition === true) {
        // On efface le parametre index dans l'url
        delete params.index
        newUrl = deleteParameter('index', newUrl)
    }

    // Ajout du ? si aucun parametre
    if (newUrl.indexOf('?') === -1) {
        noParameters = true
    }

    for (const keyParam in params) {
        if (params.hasOwnProperty(keyParam)) {
            if (keyParam == 'tri' || keyParam == 'remise') {
                continue
            }

            if ((start = newUrl.indexOf(keyParam + '=')) !== -1) {
                prefix = newUrl.substring(0, start)
                if ((end = newUrl.indexOf('&', start)) === -1) {
                    suffix = ''
                } else {
                    suffix = newUrl.substring(end, newUrl.length)
                }
                newUrl = prefix + keyParam + '=' + params[keyParam] + suffix
            } else if (!noParameters) {
                newUrl = newUrl + '&' + keyParam + '=' + params[keyParam]
            } else if (noParameters) {
                newUrl = newUrl + '?' + keyParam + '=' + params[keyParam]
                noParameters = false
            }
        }
    }
    $(J_URL_HIDDEN).first().val(newUrl)
    backBrowser = false
    history.pushState(params, document.title, newUrl)
}

/*
 * Change l'URL de la page courante
 */
function setUrl(params, newUrl) {
    $(J_PAGINATION_METHOD).data(J_ACTION, newUrl)
    $(J_ACTION_DEGRADATED).data(J_ACTION_DEGRADATED, newUrl)
    backBrowser = false
    history.pushState(params, document.title, newUrl)
}

function setUrl2(params, newUrlAvecTri, newUrlSansTri) {
    $(J_PAGINATION_METHOD).data(J_ACTION, newUrlSansTri)
    $(J_ACTION_DEGRADATED).data(J_ACTION_DEGRADATED, newUrlSansTri)
    backBrowser = false
    newUrlAvecTri = deleteParameter('ct', newUrlAvecTri)
    newUrlAvecTri = deleteParameter('ctr', newUrlAvecTri)
    history.pushState(params, document.title, newUrlAvecTri)
}

/*
 * Retourne la valeur du paramètre dont le nom est passé en paramètre
 * Si il n'est pas trouvé, defaultValue sera retourné
 */
function getParameter(paramName, defaultValue) {
    const kvp = document.location.search.substr(1).split('&')
    let i = kvp.length
    let param = ''

    paramName = encodeURI(paramName)
    while (i-- && i >= 0) {
        param = kvp[i].split('=')

        if (param[0] === paramName && paramName === 'np') {
            if (param[1] < 1) {
                return defaultValue
            } else {
                return param[1]
            }
        } else if (param[0] === paramName && paramName !== 'np') {
            return param[1]
        }
    }
    return defaultValue
}

/*
 * Retourne un objet contenant tout les paramètres de la requête
 */
function getAllParameters() {
    let url = $(J_URL_HIDDEN).val().split('?')
    let parameters = []
    const returnValue = {}
    let kpv = ''

    if (url.length > 1) {
        url = url[1]
        parameters = url.split('&')
        for (let i = 0; i < parameters.length; i++) {
            kpv = parameters[i].split('=')
            returnValue[kpv[0]] = kpv[1]
        }
    }
    return returnValue
}

/*
 * Va chercher le paramètre J_REDIRECTION_PARAMETERS et retourner sa valeur
 */
function parseRedirectionParameter() {
    const paramName = encodeURI(J_REDIRECTION_PARAMETERS)
    const kvp = document.location.search.substr(1).split('&')
    let i = kvp.length
    let param = ''

    while (i-- && i >= 0) {
        param = kvp[i].split('=')
        if (param[0] === paramName) {
            return param[1]
        }
    }
    return undefined
}

export default {
    insertParams: insertParams,
    deleteParams: deleteParameter,
    getParameter: getParameter,
    getAllParameters: getAllParameters,
    init: init,
    parseRedirectionParameter: parseRedirectionParameter,
    setUrl: setUrl,
    setUrl2: setUrl2
}
